export default function GitHubRibbon() {
    return (
        <a className="github-fork-ribbon" href="https://github.com/alaa-sufi/useful-websites" data-ribbon="Fork me on GitHub" title="Fork me on GitHub" target="_blank">Fork me on GitHub</a>

    )
}